export const normalizePhoneNumber = (phoneNumber = '') => (phoneNumber?.replace(/\D/g, ''));
export const validatePhoneNumber = (phoneNumber:string) => (/^\d{12}$/.test(phoneNumber));
